export default "__VITE_ASSET__ng7Uch8n__"